/* eslint-disable camelcase */

import { defaultTo, get } from 'lodash-es';

import page from '@/mixins/page';
import pagination from '@/mixins/pagination';

/**
 * @module pages/invest/invest021
 * @desc 재무정보 > 공고
 * @vue-data {Number} year=Number - 현재 년도
 * @vue-data {Array} options=[]] - 셀렉트 박스 년도 목록
 * @vue-data {Boolean} moreBtn=true - 더보기 버튼의 유무
 * @vue-data {Number} yearTo=null - 리스트의 표시할 년도
 */
export default {
  mixins: [page, pagination],
  data() {
    return {
      year   : new Date().getFullYear() + '년',
      options: [],
      moreBtn: true,
      yearTo : null
    };
  },
  mounted() {
    this.options = Array.from({ length: 5 })
      .fill(new Date().getFullYear())
      .map((item, idx) => item - idx + '년');
    this.$nextTick(() => {
      this.getInvest();
    });
  },
  watch: {
    year(thisY) {
      this.yearTo = this.getNum(thisY);
      this.listItems = null;
      if (this.curPageIdx === 0) {
        this.getInvest();
      } else {
        this.params.year = this.yearTo;
        this.curPageIdx = 0;
      }
    }
  },
  methods: {
    /**
     * 공고 자료 다운로드
     * @param {Number} seq 자료 번호
     */
    download(seq) {
      this.$system.download(
        `${this.axios.defaults.baseURL}/api/investDownload.do?seq=${seq}`
      );
    },
    /**
     * 문자열에서 숫자 추출
     * @param {String} value 변환 할 문자열
     * @returns 문자열에서 숫자만 반환
     */
    getNum(value) {
      return value.replace(/[^0-9]/g, '');
    },
    /**
     * 리스트 페이지 통신
     */
    getInvest() {
      if (this.device === 'mo') {
        this.loadPageData({
          uri   : '/api/getInvests.do',
          params: {
            year   : this.yearTo,
            page_no: 1
          },
          callback: (res) => {
            console.log('!!!!! pagination :', res.data);

            // 더보기 버튼
            if (this.listItems !== null) {
              this.listItems = this.listItems.concat(
                get(res.data, 'item', []).filter((item) => item.use_yn === 'Y')
              );
            } else {
              // 초기화
              this.listItems = get(res.data, 'item', []).filter(
                (item) => item.use_yn === 'Y'
              );
            }

            this.totalPageN = defaultTo(
              parseInt(get(res.data, 'totalPage')),
              1
            );
          }
        });
      } else {
        this.loadPageData({
          uri   : '/api/getInvests.do',
          params: {
            year   : this.yearTo,
            page_no: 1
          },
          callback: (res) => {
            console.log('!!!!! pagination :', res.data);

            this.listItems = get(res.data, 'item', []).filter(
              (item) => item.use_yn === 'Y'
            );
            this.totalPageN = defaultTo(
              parseInt(get(res.data, 'totalPage')),
              1
            );
          }
        });
      }
    }
  }
};
